export default __webpack_public_path__ + "static/media/mandira.7a86254e.jpg";